import { createContext, useContext } from 'react';
import type { TenantConfig } from './config/tenants';

export type FeatureFlagsState = {
  flags: Record<string, boolean>;
  enabledRetailers: string[];
  tenant: TenantConfig;
};

// The context and its hooks live here, away from FeatureFlagsProvider.tsx, so
// that the provider file only exports a component (React Fast Refresh).
export const FeatureFlagsContext = createContext<FeatureFlagsState | undefined>(
  undefined
);

export const useFeatureFlags = (): FeatureFlagsState => {
  const ctx = useContext(FeatureFlagsContext);
  if (!ctx) {
    throw new Error(
      'useFeatureFlags must be used within a FeatureFlagsProvider'
    );
  }
  return ctx;
};

export const useFeatureFlag = (key: string): boolean => {
  const { flags } = useFeatureFlags();
  if (!key) return false;
  return Boolean(flags[key.trim().toLowerCase()]);
};

export const useEnabledRetailers = (): string[] => {
  const { enabledRetailers } = useFeatureFlags();
  return enabledRetailers;
};

export const useTenant = (): TenantConfig => {
  const { tenant } = useFeatureFlags();
  return tenant;
};
